import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  TextField,
  Button,
  CircularProgress,
  Box,
  Typography,
  Snackbar,
  Alert,
  styled,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCreateManagerMutation } from "../../../services/profileService";

const CreateManager = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [createManager, { isLoading }] = useCreateManagerMutation();
  // const [apiError, setApiError] = useState("");

  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const onSubmit = async (data) => {
    try {
      // setApiError(""); // Clear previous errors
      await createManager(data).unwrap();
      // alert("Manager added and email sent successfully!");
      setToastMessage("Manager added and email sent successfully!");
      setToastSeverity("success");
      setToastOpen(true);

      // Delay navigation slightly so user can see the toast
      setTimeout(() => {
        navigate("/manager-dashboard");
      }, 3000);
      // navigate("/manager-dashboard");
    } catch (error) {
      console.error("Error creating manager:", error);
      // alert(error?.message)
      setToastMessage(error?.message || "This email is already registered. Please use another email.");
      setToastSeverity("warning");
      setToastOpen(true);
      // Check for known API errors and set error message
      if (error?.status) {
        // setApiError(error?.status);
        // console.log(apiError);

        // Show API error message
      } else {
        // setApiError("An unexpected error occurs!");
      }
    }
  };
  const handleToastClose = () => {
    setToastOpen(false);
  };

  return (
    <>
      <SectionWrap>
        <ContainerWrap>
          <RowWrap>
            <Col12Wrap sx={{ textAlign: "center", marginBottom: "20px" }}>
              <Typography
                sx={{
                  fontSize: "25px",
                  textAlign: "center",
                  fontWeight: "500",
                  margin: "0 10px",
                  color: "#2C2C2E",
                }}
              >
                Add New Manager
              </Typography>
            </Col12Wrap>
            <Col12Wrap>
              <form onSubmit={handleSubmit(onSubmit)}>
                <FormMiddleBoxWrap>
                  <RowWrap>
                    <Col6Wrap>
                      <FormGroupWrap>
                        <FormLabelWrap>Name</FormLabelWrap>
                        <CustomTextField
                          fullWidth
                          variant="outlined"
                          {...register("name", {
                            required: "Name is required",
                          })}
                          placeholder="Manager Name"
                          error={!!errors.name}
                        />
                        {errors.name && (
                          <ErrorText>{errors.name.message}</ErrorText>
                        )}
                      </FormGroupWrap>
                    </Col6Wrap>
                    <Col6Wrap>
                      <FormGroupWrap>
                        <FormLabelWrap>Email</FormLabelWrap>
                        <CustomTextField
                          fullWidth
                          variant="outlined"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value:
                                /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                              message: "Invalid email format",
                            },
                          })}
                          placeholder="Manager Email"
                        />
                        {errors.email && (
                          <ErrorText>{errors.email.message}</ErrorText>
                        )}
                      </FormGroupWrap>
                    </Col6Wrap>
                    <Col6Wrap>
                      <FormGroupWrap sx={{ marginBottom: "0" }}>
                        <FormLabelWrap>Password</FormLabelWrap>
                        <CustomTextField
                          fullWidth
                          variant="outlined"
                          type="password"
                          {...register("password", {
                            required: "Password is required",
                          })}
                          placeholder="Password"
                        />
                        {errors.password && (
                          <ErrorText>{errors.password.message}</ErrorText>
                        )}
                      </FormGroupWrap>
                    </Col6Wrap>
                    <Col6Wrap>
                      <FormGroupWrap sx={{ marginBottom: "0" }}>
                        <FormLabelWrap>Job Title</FormLabelWrap>
                        <CustomTextField
                          fullWidth
                          variant="outlined"
                          {...register("job_title", {
                            required: "job_title is required",
                          })}
                          placeholder="Job Title"
                        />
                        {errors.job_title && (
                          <ErrorText>{errors.job_title.message}</ErrorText>
                        )}
                      </FormGroupWrap>
                    </Col6Wrap>
                  </RowWrap>
                </FormMiddleBoxWrap>
                <FormBtnBoxWrap>
                  <RowWrap>
                    <Col12Wrap sx={{ textAlign: "center" }}>
                      <CustomBtn
                        type="submit"
                        variant="outlined"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <CircularProgress size={24} />
                        ) : (
                          "Add Manager"
                        )}
                      </CustomBtn>
                    </Col12Wrap>
                  </RowWrap>
                </FormBtnBoxWrap>
              </form>
            </Col12Wrap>
          </RowWrap>
        </ContainerWrap>
      </SectionWrap>
      <Snackbar
        open={toastOpen}
        autoHideDuration={3000} // Close after 3s
        onClose={handleToastClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleToastClose}
          severity={toastSeverity}
          variant="filled"
        >
          {toastMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CreateManager;

const SectionWrap = styled(Box)(() => ({
  padding: "30px 0 100px",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1170px",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormMiddleBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const Col6Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "50%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 767px)": {
    width: "100%",
  },
}));
const FormGroupWrap = styled(Box)(() => ({
  marginBottom: "30px",
  position: "relative",
}));
const CustomTextField = styled(TextField)(() => ({
  width: "99%",
  border: "1px solid #DADADA",
  borderRadius: "7px",
  "& .MuiInputBase-input": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "1",
    color: "#2C2C2E",
    padding: "14px 20px",
  },
  "& fieldset": {
    border: "none",
  },
}));
const ErrorText = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "1.445",
  color: "#ff0000",
  marginTop: "5px",
}));
const FormBtnBoxWrap = styled(Box)(() => ({
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "30px",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
  },
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "20px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  padding: "15px 15px",
  maxWidth: "250px",
  boxShadow: "none !important",
}));
const FormLabelWrap = styled(Typography)(() => ({
  fontSize: "18px",
  fontWeight: "400",
  lineHeight: "1.445",
  color: "#2C2C2E",
  marginBottom: "5px",
}));
